<template>
  <div id="admin" class="form">
    <h1>Admin</h1>
    <b-container>
      <b-row>
        <b-col sm="4">
          <b-form-group label="Admin password"
                        label-for="input-password"
                        label-class="font-weight-bold">
            <b-form-input v-model="password"
                          id="input-password"
                          type="password"
                          autofocus/>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Provider"
                        label-class="font-weight-bold">
            <b-form-select v-model="provider" :options="providers"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Environment"
                        label-class="font-weight-bold">
            <b-form-select v-model="environment" :options="environments"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="text-center">
          <b-button :disabled="syncBusy"
                    class="mx-4 px-5 my-3"
                    @click="onSync">
            Synchronize CTAGs
          </b-button>
          <b-button :disabled="checkBusy"
                    class="mx-4 px-5 my-3"
                    @click="onCheck">
            Check Accounts
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <template v-if="response">
            <pre>
              {{ response }}
            </pre>
          </template>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'AdminView',
  components: {},
  props: {},
  data() {
    return {
      endpoints: {
        production: 'https://4kryo7fts6.execute-api.us-east-1.amazonaws.com',
        staging: 'https://bgzpvae4cg.execute-api.us-east-1.amazonaws.com',
        development: 'https://m1k6vi1p26.execute-api.us-east-1.amazonaws.com',
        localhost: 'http://localhost:3000'
      },
      password: null,
      environment: 'production',
      environments: [
        {value: 'production', text: 'Production'},
        {value: 'staging', text: 'Staging'},
        {value: 'development', text: 'Development'},
        {value: 'localhost', text: 'Local'},
      ],
      provider: 'sherburne',
      providers: [
        {value: 'jamestown', text: 'Jamestown'},
        {value: 'sherburne', text: 'Sherburne'},
      ],
      syncBusy: false,
      checkBusy: false,
      response: null,
    }
  },
  methods: {
    async onSync() {
      console.log(`Admin:onSync  this.environment="${this.environment}"`)
      this.response = null
      try {
        this.syncBusy = true;
        // endpoint
        const endpoint = this.endpoints[this.environment]
        const payload = {
          action: 'entpnt_sync_' + this.provider,
          data: {
            password: this.password
          }
        }
        const fetchOptions = {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(payload)
        }
        const response = await fetch(endpoint, fetchOptions)
        console.log('Admin:onSync  response=', response)
        if (response.ok) {
          //this.response = `Sync ${this.provider} OK`
          response.json()
            .then(json => {
              if (json.data) {
                this.response = json.data
              } else {
                response.text()
                  .then(data => {
                    this.response = data
                  })
              }
            })
        } else {
          throw new Error(response.statusText ?? response.text)
        }
        //const data = await response.json();
      } catch (error) {
        console.error('Admin:onSync  error=', error)
        this.response = `Sync error: ${error.message ?? error}`
      } finally {
        this.syncBusy = false;
      }
    },
    async onCheck() {
      console.log(`Admin:onSync  this.environment="${this.environment}"`)
      this.response = null
      try {
        this.checkBusy = true;
        // endpoint
        const endpoint = this.endpoints[this.environment]
        const payload = {
          action: 'entpnt_check',
          data: {
            password: this.password
          }
        }
        const fetchOptions = {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(payload)
        }
        const response = await fetch(endpoint, fetchOptions)
        console.log('Admin:onCheck  response=', response)
        if (response.ok) {
          response.json()
            .then(json => {
              if (json.data) {
                this.response = json.data
              } else {
                response.text()
                  .then(data => {
                    this.response = data
                  })
              }
            })
        } else {
          throw new Error(response.statusText ?? response.text)
        }
        //const data = await response.json();
      } catch (error) {
        console.error('Admin:onCheck  error=', error)
        this.response = `Check error: ${error.message ?? error}`
      } finally {
        this.checkBusy = false;
      }
    },
  },
}
</script>

<style lang="scss">
#admin {
}
</style>